import { render } from "./ShipFromBranch.vue?vue&type=template&id=659e394c&scoped=true"
import script from "./ShipFromBranch.vue?vue&type=script&lang=js"
export * from "./ShipFromBranch.vue?vue&type=script&lang=js"

import "./ShipFromBranch.vue?vue&type=style&index=0&id=659e394c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659e394c"]])

export default __exports__